import React, { useState, useEffect } from 'react';
import { Box, useTheme } from '@mui/material';
import { keyframes } from '@emotion/react';
import { styled } from '@mui/material/styles';
import home1 from '../../Assests/home1.png'
import home2 from '../../Assests/home2.png'
import home3 from '../../Assests/home3.png'

// Replace these with your actual image paths
const images = [
  home1,
  home2,
  home3
];

const fadeInOut = keyframes`
  0% { opacity: 0; }
  10% { opacity: 1; }
  33% { opacity: 1; }
  43% { opacity: 0; }
  100% { opacity: 0; }
`;

const Dot = styled(Box)({
  width: 10,
  height: 10,
  borderRadius: '50%',
  margin: '0 4px',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease',
  '&.active': {
    backgroundColor: '#10b981',
  },
  '&:not(.active)': {
    backgroundColor: '#ffffff',
    opacity: 0.3,
  },
  '&:hover:not(.active)': {
    backgroundColor: '#ffffff',
    opacity: 0.5,
  },
});

const DotsContainer = styled(Box)({
  position: 'absolute',
  bottom: '20px',
  left: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'center',
  zIndex: 3,
});

const HeroSection = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const theme = useTheme();

  const goToSlide = (index) => {
    setCurrentImageIndex(index);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Slightly longer interval for better visibility

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      {images.map((image, index) => (
        <Box
          key={index}
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url(${image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            opacity: index === currentImageIndex ? 1 : 0,
            transition: 'opacity 0.5s ease-in-out',
            zIndex: 1,
          }}
        />
      ))}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 2,
          textAlign: 'center',
          color: 'white',
          textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
          maxWidth: '90%',
        }}
      >
        
      </Box>
      <DotsContainer>
        {images.map((_, index) => (
          <Dot
            key={index}
            className={currentImageIndex === index ? 'active' : ''}
            onClick={() => goToSlide(index)}
          />
        ))}
      </DotsContainer>
    </Box>
  );
};

export default HeroSection;